import { Container, Row, Col } from 'react-bootstrap'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { withOpenAccessPage } from '@srca-b2b/kp5-ui-common/utils/auth'
import styles from './eula.module.scss'

const EulaEts = () => {
  return (
    <Layout>
      <Container>
        <UspPageTitle title="terms and conditions" />
        <Row className={styles.termsAndConditionsWrapper}>
          <Col sm={12}>
            <h2 className={styles.header}>
              Terms of Service for Samsung Enterprise Technical Support and Samsung Partner
              Technical Support
            </h2>
            <div className={styles.customListContent}>
              <p>
                By accepting these TOS, placing your order (the “Order”) for the Services, receiving
                delivery of the Services, utilizing the Services, or clicking/checking any “I Agree”
                button or box or similar on the Samsung Enterprise Technical Support website or
                related systems in connection with your purchase, you agree to be bound by these
                TOS.
              </p>
              <p>
                These TOS are agreed between (i) you, either individually if you are agreeing to it
                in your own capacity, or if you are authorized to agree to these terms on behalf of
                your company or another entity, between the entity for whose benefit you act (in
                either case, "you", “your”, "Company" or “Customer”, as specified below), and (ii)
                Samsung entity with which you have an effective agreement or order that refers to
                this TOS ("Samsung"). The Services are solely for your internal use and may not be
                resold.
              </p>
              <p>
                Capitalized terms used but not defined in these TOS shall have the meanings as set
                forth in the applicable Order.
              </p>
              <ol start="1" type="1">
                <li>SERVICE</li>
                <p>
                  “Services” means each Samsung Enterprise Technical Support and Samsung Partner
                  Technical Support service offering as described in a service guide (each, a
                  “Samsung Enterprise Technical Service Guide” and a"Samsung Partner Technical
                  Support") set forth at https://www.samsungknox.com/ets and/or via other hotlines,
                  which may be updated time to time by sole discretion of Samsung without notice.
                  Each Samsung Enterprise Technical Support Service Guide and Samsung Partner
                  Technical Support Service Guide describes: (i) available service options; (ii)
                  specific projects, tasks, functions, responsibilities and services to be furnished
                  by Samsung to Company; (iii) deliverables to be provided (the “Deliverables”);
                  (iv) assumptions, conditions and dependencies impacting the Services or upon which
                  the pricing or delivery of the Services might be based; (v) additional TOS that
                  apply to the particular Services (for example, service levels, performance
                  requirements, milestones, project plans, acceptance testing, and license rights
                  for Deliverables); and (vii) the duration of the Services (the “Service Term”).
                </p>
                <p>
                  Service will be provided from the Service Start Date to the Service End Date (as
                  defined below). Unless otherwise set forth in an Order, Company’s acceptance of
                  the Services occurs upon performance of the Services by Samsung.
                </p>
                <p>
                  Charges and expenses for the Services will be set out in the applicable Order
                  (“Fees”)
                </p>
                <ul>
                  <li>1.1. SERVICE MANAGER</li>
                  <p>
                    All communications regarding any Order shall be directed to the applicable
                    Company or Samsung contacts. The Samsung and Company contacts shall have the
                    authority to act on behalf of the respective party in all day-to-day matters
                    pertaining to the applicable Order, but shall not have the authority, through
                    action, inaction or otherwise, to amend or modify these TOS or an Order. Either
                    party may change its designated contact upon prior written notice to the other
                    party.
                  </p>
                  <li>1.2. SERVICE LOCATION</li>
                  <p>
                    Samsung may provide the Services (or portions thereof) from any location
                    determined by Samsung or relocate the provision of the Services (or any portion
                    thereof).
                  </p>
                  <li>1.3. ACCESS AND USE</li>
                  <p>
                    Company acknowledges that it is responsible (administratively and financially)
                    for obtaining all required approvals, licenses, authorizations, consents, and
                    permits for Samsung to use or access the Company sites or Company contractor
                    sites, with such sites being kept free of health and safety hazards.
                  </p>
                  <li>1.4. CHANGES TO SCOPE OF SERVICES</li>
                  <p>
                    Samsung or Company may request changes to the then existing scope of Services or
                    Deliverables, including new or additional services, in accordance with the
                    following change control procedures. All change requests will: (i) be in
                    writing; (ii) have a description of the requested change; (iii) describe the
                    purpose for the change; (iv) determine the priority of the change; (v) reflect
                    the date of requested implementation; (vi) identify the pricing impact of the
                    change, if any; and (vii) give the name of the individual authorized to request
                    such changes. Changes requested will be reviewed by the receiving party as soon
                    as possible, and all changes mutually agreed to by the parties will become
                    effective upon the date set forth in the document executed by both parties
                    describing such changes.
                  </p>
                  <li>1.5. COMPANY OBLIGATIONS</li>
                  <p>
                    Company acknowledges that the ability of Samsung to provide certain Services and
                    Deliverables in accordance with these TOS and the associated Order (including
                    the agreed pricing and delivery models) are contingent upon, and Company
                    represents, warrants and covenants that: (i) the Company Materials (as defined
                    below) provided by Company shall be accurate, complete and accessible in the
                    manner and in the format required by Samsung; and (ii) Company will cooperate
                    and provide timely performance of its obligations.
                  </p>
                  <p>
                    In the event any Company Materials are found to be inaccurate, incomplete or not
                    properly accessible or formatted, or Company fails to perform its obligations,
                    in addition to Section 2.5 below, the parties agree to negotiate in good faith
                    equitable changes to the impacted Order, which may include, without limitation,
                    changes to the Fees charged to Company. Company is responsible for completing
                    and maintaining a backup of all existing data, content, programs and Samsung
                    will have no liability for loss or recovery of data or programs, or loss of use
                    of systems arising out of the Services.
                  </p>
                  <p>
                    If you have ordered a Samsung technical support services offering, Samsung will
                    provide Company’s Named Callers (as defined in the applicable service guide)
                    with log-in credentials for access to Samsung’s Support Portal for the purposes
                    of creating and tracking Company support requests (the “Support Portal”).
                    Company agrees not to: (i) license, sublicense, sell, resell, rent, lease,
                    transfer, assign, distribute, time share or otherwise commercially exploit or
                    make the Support Portal available to any third party, other than the Named
                    Callers; (ii) modify, adapt, or otherwise attempt to gain unauthorized access to
                    the Support Portal or related systems or networks; (iii) use the Support Portal
                    in any unlawful manner; (iv) use the Support Portal in any manner that
                    interferes with or disrupts the integrity or performance of the Services and its
                    components; (v) attempt to decipher, decompile, reverse engineer or otherwise
                    discover the source code of any software making up the Support Portal; (vi) use
                    the Support Portal to store or transmit any sensitive personal data; or (vii)
                    use the Support Portal to knowingly post, transmit, upload, link to, send or
                    store any viruses, malware, Trojan horses, time bombs, or any other similar
                    harmful software. Samsung may suspend Company’s access to the Support Portal if
                    Samsung becomes aware of any non-compliance with the foregoing provisions and
                    Samsung shall not be liable to Company or any other third party for any such
                    suspension or discontinuation of Company’s access and use of the Support Portal.
                  </p>
                  <li>1.6. SUBCONTRACTING</li>
                  <p>
                    Samsung may, at its option and in its sole discretion, subcontract all or any
                    part of its obligations under any Order (including to an Affiliate of Samsung).
                    In the event that Samsung subcontracts any of its obligations, Samsung shall be
                    responsible and liable for any such subcontractor or subcontractor personnel
                    performance to the same extent as if such obligations were performed by Samsung
                    or Samsung employees. For the purposes of these TOS, an “Affiliate” of a party
                    means an entity controlling, controlled by, or under common control with that
                    party. “Control” means direct or indirect control of fifty percent (50%) or more
                    of the voting power to elect directors thereof, or for any other entity, the
                    power to direct the management of such entity.
                  </p>
                  <li>1.7. INSURANCE</li>
                  <p>
                    Samsung and Company shall each maintain insurance in commercially reasonable
                    amounts to protect itself and the other party from any and all claims of nature
                    for damage to property or personal injury (including death) made by anyone, that
                    may arise from activities performed or facilitated under these TOS or an Order
                  </p>
                </ul>
                <li>ORDERING, COST AND PAYMENT</li>
                <ul>
                  <li>2.1. ORDER</li>
                  <p>
                    "Order" means the submission of a Company purchase order to Samsung that
                    references and incorporates a Samsung quote, Samsung Service Guide, order
                    acknowledgement, order form, service schedule, statement of work, Services SKU
                    or any other mutually-agreed form of order (including those accessible by URL),
                    together with these TOS. No pre-written terms of your purchase order will be
                    binding on Samsung.
                  </p>
                  <p>
                    After receipt of your Order, Samsung will provide you with a scheduled date for
                    the start of the Services (the “Service Start Date”) and for the end of the
                    Services (the “Service End Date”). Your Order is considered binding by Samsung
                    and non-cancellable by you once Samsung has provided you with a Service Start
                    Date. The parties may enter into one or more Orders and each Order is
                    independent from any other Order.
                  </p>
                  <p>
                    Quoted prices are effective until the expiration date of the Samsung quote.
                    Samsung reserves the right, for any reason or for no reason whatsoever, to
                    reject any Order received from Customer. Samsung may revise or discontinue
                    Services at any time without penalty, including after Customer places an Order,
                    but prior to the Service Start Date.
                  </p>
                  <li>2.2. PAYMENT</li>
                  <p>
                    Company shall pay Samsung the Fees. Any increases in the Fees or cost of
                    conducting the Services or providing the Deliverables incurred by reason of a
                    Company request for a change in scope or modification of the Services or
                    Deliverables shall be borne by Company.
                  </p>
                  <p>
                    Samsung shall issue invoices in accordance with the Order. Company shall pay all
                    amounts due under an Order within thirty (30) days after the date of the
                    applicable invoice.
                  </p>
                  <li>2.3. TRAVEL AND LODGING</li>
                  <p>
                    Unless otherwise agreed in the applicable Order, the Fees are exclusive of any
                    travel, lodging or other living expenses incurred in Samsung’s provision of the
                    Services. Company shall promptly reimburse Samsung for Samsung’s reasonable
                    expenses actually incurred in the performance of the Services hereunder upon
                    Samsung’s presentation to Company of reasonable documentation evidencing such
                    expenses.
                  </p>
                  <li>2.4. TAXES</li>
                  <p>
                    All costs shall be exclusive of taxes. Any taxes, duties, excises or tariffs
                    imposed on Fees paid in respect of an Order shall be the responsibility of
                    Company notwithstanding any change in law, policy or tax rate impacting the
                    amount of taxes required to be remitted in connection with an invoice referred
                    to in Section 2.2; provided, however, that Company shall have no responsibility
                    for taxes calculated solely by reference to the net income of Samsung. If
                    Samsung is required by law to directly pay any taxes, fees, excises, tariffs or
                    other charges for which Company has responsibility pursuant to this Section 2.4,
                    Company shall promptly reimburse Samsung upon Samsung’s presentation to Company
                    of documentation evidencing such payment.
                  </p>
                  <li>2.5. CREDIT</li>
                  <p>
                    Samsung may, in its sole discretion, agree to extend credit to Company. Company
                    shall comply with Samsung’s policies and procedures regarding the extension of
                    credit to Companies. Samsung may revoke or reduce credit approval at any time
                    without prior notice. Company shall complete a Samsung credit application and if
                    requested, provide financial statements prior to Samsung’s execution of any
                    Order. In the event that Samsung, in its sole discretion, does not approve
                    Company’s credit, Samsung may elect to grant payment terms of cash in advance or
                    some other agreed upon fully secured option such as a stand-by letter of credit,
                    or such other terms as Samsung shall determine.
                  </p>
                  <li>2.6. LATE PAYMENT</li>
                  <p>
                    Payment terms shall be strictly enforced, and late payments shall be assessed
                    monthly interest equal to two percent (2%) per annum above the base rate for the
                    time being of HSBC Bank plc or its successor or the maximum rate permitted by
                    applicable law. Should Company fail to make timely payments under an Order,
                    Samsung may, at its discretion, suspend further performance of all Services,
                    without limiting any other remedies it may have pursuant to these TOS. If
                    Company fails to pay any due and payable amounts within ten (10) days after
                    receipt of Samsung’s written notice that such amounts are past due, Company
                    shall be deemed to be in material breach hereunder and Samsung may immediately
                    terminate any Order and pursue all other remedies. Should it become necessary to
                    institute collection proceedings for amounts invoiced to Company and unpaid
                    following the applicable due date, Company shall pay all reasonable
                    out-of-pocket costs and expenses incurred by Samsung in connection with such
                    proceedings, including without limitation reasonable attorneys’ fees, without
                    regard to whether a suit is filed by Samsung.
                  </p>
                </ul>
                <li>REPRESENTATIONS, WARRANTIES AND CONVENANTS OF COMPANY</li>
                <p>As of the date of each Order hereunder:</p>
                <ul>
                  <li>3.1. FORMATION; AUTHORITY</li>
                  <p>
                    Company represents, warrants and covenants that: (a) it is duly formed, validly
                    existing and in good standing under the laws of the country of its formation;
                    (b) it has all requisite power and authority to execute, deliver and perform its
                    obligations under these TOS and any Order, and any executed modification
                    thereof; (c) its performance under these TOS and any Order have been duly
                    authorized by all requisite corporate action; and (d) that these TOS together
                    with the Order constitutes the legal, valid and binding agreement of Company,
                    enforceable against it in accordance with its terms.
                  </p>
                  <li>3.2. ANTI-BRIBERY</li>
                  <p>Company represents, warrants and covenants that –</p>
                  <ul>
                    <li>
                      3.2.1. it is fully aware of and will comply with, and will not take any action
                      or omit to take any action that would cause either Company or Samsung to be in
                      violation any applicable anti-corruption laws, or any regulations promulgated
                      under any such laws.
                    </li>
                    <li>
                      3.2.2. neither it nor any of its employees is an official or employee of any
                      government (or any department, agency or instrumentality of any government),
                      political party, state owned enterprise or a public international organization
                      such as the United Nations, or a representative or any such person (each, an
                      “Official”).
                    </li>
                    <li>
                      3.2.3. to its knowledge, neither it nor any of its employees has offered,
                      promised, made or authorized to be made, or provided any contribution, thing
                      of value or gift, or any other type of payment to, or for the private use of,
                      directly or indirectly, any Official for the purpose of influencing or
                      inducing any act or decision of the Official to secure an improper advantage
                      in connection with, or in any way relating to, (i) any government
                      authorization or approval involving Samsung, or (ii) the obtaining or
                      retention of business by Samsung.
                    </li>
                    <li>
                      3.2.4. it will not in the future offer, promise, make or otherwise allow to be
                      made or provide any such payment and that it will take all lawful and
                      necessary actions to ensure that no such payment is promised, made or provided
                      in the future by any of its employees.
                    </li>
                    <p>
                      If Company does not abide with any of the above mentioned representations,
                      warranties, or covenants, then Samsung shall reserve its right to terminate
                      all Orders immediately without any prior notice or penalty, in addition to any
                      other remedies available to it at law and/or in equity.
                    </p>
                  </ul>
                  <li>3.3. COMPANY MATERIALS</li>
                  <p>Company represents, warrants and covenants that –</p>
                  <ul>
                    <li>
                      3.3.1. it possesses all necessary rights and licenses to all information,
                      data, intellectual property, software, services, systems, facilities or other
                      materials it provides to Samsung under an Order (collectively, “Company
                      Materials”);
                    </li>
                    <li>
                      3.3.2. Samsung’s use of any Company Materials does not contravene, violate or
                      conflict with any other agreement to which Company or any other applicable
                      party that is the owner of, or has any right to, a particular Company Material
                      is a party; and
                    </li>
                    <li>
                      3.3.3. Samsung’s use of any Company Materials in connection with performing
                      its obligations under these TOS or an Order (including, but not limited to
                      incorporating, including or embedding Company Materials into, or using Company
                      Materials in connection with creating any Deliverables) does not infringe,
                      misappropriate or violate any third party right; and
                    </li>
                    <li>
                      3.3.4. if any Company Materials include or make use of any free, open source
                      or other publicly available software (“FOSS”) and such Company Materials are
                      to be embedded in or used in conjunction with a Deliverable, Company will
                      provide Samsung with a complete and accurate list of such FOSS, including a
                      copy of the applicable FOSS licenses and copyright notices.
                    </li>
                  </ul>
                </ul>
                <li>LIMITED WARRANTIES</li>
                <ul>
                  <li>4.1. SAMSUNG WARRANTIES</li>
                  <p>
                    Samsung warrants to Company that all Services (a) shall be performed in a
                    professional and workmanlike manner in accordance with reasonable standards of
                    the industry; and (b) shall conform in all material respects to the written
                    specifications set forth in the applicable Samsung Service Guide at the time of
                    performance. Company’s sole remedy for any breach of the warranty provided in
                    this Section 4.1 or any warranty related to the Services provided in any Order
                    shall be re-performance of any Services found to be defective thereunder.
                  </p>
                  <li>4.2. DISCLAIMER OF WARRANTIES</li>
                  <p>
                    Except as expressly provided in this section 4 with respect to Services or in an
                    Order, Samsung provides the Services and deliverables on an “as is,” “where is”
                    basis and makes no other representations or warranties, express or implied, as
                    to the services or Deliverables, including any warranty of merchantability,
                    fitness for a particular purpose or non-infringement. Further, Samsung does not
                    warrant that the Services or Deliverables will meet Company’s requirements or
                    any legal or other requirements, or that the operation of the Services or
                    deliverables will be uninterrupted or error-free.
                  </p>
                </ul>
                <li>CONFIDENTIALITY</li>
                <p>
                  “Confidential Information” shall mean all business information, technical data or
                  know-how, in whatever form, which the disclosing party (the “Discloser”) transmits
                  to the receiving party (the “Recipient”) in any manner relating to the properties,
                  business activities or operations of Discloser, including (i); all information of
                  Discloser that is not known to the public, without regard to the form in which
                  such information is disclosed; (ii) any and all of the foregoing which is prepared
                  by Recipient or its employees or agents that contains, reflects or is based upon,
                  in whole or in part, any of the Confidential Information; and (iii) the contents
                  of discussions and negotiations between the parties concerning the Services or
                  Deliverables. Confidential Information shall not include information that
                  Recipient can demonstrate: (A) is or (through no improper action or inaction by
                  Recipient or any affiliate, agent, consultant or employee of Recipient) becomes
                  part of the public domain; (B) was lawfully in the possession of or known by
                  Recipient on a non-confidential basis at the time of disclosure by Discloser; (C)
                  was received on a non-confidential basis from a third party having a lawful right
                  to disclose such information; or (D) was independently developed by Recipient
                  without reference to or use of the Confidential Information of Discloser as
                  demonstrated by Recipient’s records.
                </p>
                <ul>
                  <li>5.1. NON-DISCLOSURE AND USE</li>
                  <p>
                    Recipient agrees to keep confidential and not to use the Confidential
                    Information of Discloser for any purpose other than in furtherance of the
                    performance or receipt of the Services, or with respect to Samsung as Recipient,
                    the provision of the Services or Deliverables. Recipient shall not disclose
                    Discloser’s Confidential Information to any person or entity other than
                    Recipient’s employees, agents, advisors, subcontractors, and service providers
                    and representatives with a need to know the Confidential Information in order to
                    carry out the purpose contemplated by these TOS and who agree to be bound by
                    Recipient’s obligations under these TOS with regard to nondisclosure and use of
                    such Confidential Information. Recipient will not (and will cause its employees,
                    Affiliates or agents not to) reverse-engineer, decompile or disassemble any part
                    of, or remove any proprietary marking from, Discloser’s Confidential
                    Information.
                  </p>
                  <li>5.2. CARE</li>
                  <p>
                    Recipient shall use at least the same degree of care to safeguard and to prevent
                    disclosure to third parties of Confidential Information as it employs to
                    safeguard its own information of a similar nature, but in no event less than
                    reasonable care. Recipient shall promptly (i) notify Discloser in writing of the
                    details and circumstances of any unauthorized disclosure, misuse or
                    misappropriation of any of Discloser’s Confidential Information (an
                    “Unauthorized Use”) which may come to Recipient’s attention; (ii) use best
                    efforts to rectify or cure such Unauthorized Use and retrieve any such disclosed
                    Confidential Information; and (iii) use best efforts to provide assistance to
                    and cooperate with Discloser to rectify or cure such Unauthorized Use and to
                    prevent further misuse or disclosure of such Confidential Information.
                  </p>
                  <li>5.3. MANDATORY DISCLOSURE</li>
                  <p>
                    If Recipient becomes legally compelled to disclose any of Discloser’s
                    Confidential Information, Recipient shall (i) promptly notify Discloser of such
                    requirement before any disclosure is made so that Discloser may seek a
                    protective order or other appropriate remedy limiting disclosure or use of such
                    information; and (ii) provide reasonable assistance to Discloser to seek such
                    remedy at Discloser’s expense. If such protective order or other remedy is not
                    obtained, Recipient may furnish only that portion of such Confidential
                    Information that, in the written opinion of its legal counsel, it is legally
                    required to disclose, and Recipient agrees to make commercially reasonable
                    efforts to obtain assurance that confidential treatment will be accorded to the
                    Confidential Information.
                  </p>
                  <li>5.4. OWNERSHIP, NO RIGHTS GRANTED</li>
                  <p>
                    Discloser will retain the title and full ownership rights to its Confidential
                    Information. No license, express or implied, in the Confidential Information is
                    granted to Recipient other than to use the information in the manner and to the
                    extent expressly authorized herein.
                  </p>
                  <li>5.5. RETURN OF CONFIDENTIAL INFORMATION</li>
                  <p>
                    Upon the written request of Discloser, all of Discloser’s Confidential
                    Information in tangible form shall be, at Discloser’s sole discretion, either
                    promptly returned to Discloser or promptly destroyed by Recipient, and in either
                    case not retained by Recipient or its Affiliates in any form; provided, however,
                    if Confidential Information cannot be purged from Recipient’s information or
                    communications systems using commercially reasonable efforts, Recipient shall
                    suppress such Confidential Information and allow it to be accessible only to
                    Recipient’s employees with administrative privileges who shall be subject to a
                    confidentiality obligation to Recipient at least as protective as those
                    contained in these TOS. Notwithstanding anything to the contrary contained
                    herein, Recipient’s legal department may retain an archival copy of all or any
                    portion of Discloser’s Confidential Information to the extent required by
                    applicable law or regulation or for the purpose of defending or prosecuting
                    claims relating to these TOS. The rights and obligations of the parties
                    regarding the non-disclosure and use of Confidential Information exchanged under
                    these TOS will survive any return, retention or destruction of any Confidential
                    Information.
                  </p>
                  <li>5.6. REMEDIES</li>
                  <p>
                    The parties acknowledge and agree that monetary damages would not be a
                    sufficient remedy for any breach of this Section 5, and that any such breach may
                    cause immediate and irreparable harm. Accordingly, each party agrees that, in
                    the event of any breach or threatened breach of this Section 5 by Recipient,
                    Discloser shall be entitled to seek, in addition to all remedies otherwise
                    available at law or in equity, injunctive relief.
                  </p>
                </ul>
                <li>INTELLECTUAL PROPERTY</li>
                <p>
                  Unless otherwise set forth in an Order, the following provisions in this Section 6
                  will apply to the Orders under these TOS.
                </p>
                <ul>
                  <li>6.1. SAMSUNG INTELLECTUAL PROPERTY</li>
                  <p>
                    As between Samsung and Company, Samsung will own all copyrights, patents,
                    trademarks, trade secrets, and other intellectual property rights (“IPR”) in any
                    materials, know-how, methodologies, processes, techniques, tools, forms,
                    templates, and software (whether written or machine-readable), collectively
                    “Materials” that are: (i) owned by or licensed to Samsung, its subcontractors,
                    or their respective Affiliates prior to the Service Start Date, (ii) developed
                    by Samsung, its subcontractors, or their respective Affiliates during the
                    provision of the Services or the development or delivery of the Deliverables
                    (including the Deliverables, themselves), or otherwise used by Samsung to
                    perform the Services or develop or deliver the Deliverables, or (iii)
                    modifications, enhancements, and derivative works of the Materials described in
                    (i) through (ii) (collectively, “Samsung IPR”). For the avoidance of doubt,
                    Samsung IPR does not include Company Materials provided to Samsung for Samsung’s
                    use in connection with the Services or delivery of the Deliverables.
                  </p>
                  <li>6.2. LICENSE TO SAMSUNG</li>
                  <p>
                    Company grants to Samsung a non-exclusive, irrevocable, perpetual, royalty-free,
                    sub-licensable and transferable right and license to use, copy, make derivative
                    works of, distribute, display, sublicense any Company Materials solely to the
                    extent necessary for Samsung to provide the Services and Deliverables under
                    these TOS and any Order.
                  </p>
                  <li>6.3. LICENSE TO COMPANY FOR DELIVERABLES</li>
                  <p>
                    With respect to any Deliverables that constitute software (a “Software
                    Deliverable”), subject to Customer’s compliance with: (i) these TOS; (ii) the
                    terms of an Order; and (iii) the terms of any applicable third party licenses of
                    IPR included in a Software Deliverable, Samsung grants Customer a non-exclusive,
                    non-transferable, non-sublicensable, revocable and limited license to use, copy,
                    install and display such Software Deliverables solely for the internal use of
                    Customer or its Affiliates for the original purpose and functionality of that
                    Deliverable. If any Samsung IPR, or a portion thereof, is delivered with a
                    Software Deliverable, Samsung hereby grants to Customer a non-exclusive, royalty
                    free, fully paid up, revocable license to use, copy, install and display such
                    Samsung IPR, provided however that the foregoing license does not authorize
                    Customer to separate Samsung IPR from the Software Deliverable with which it was
                    delivered.
                  </p>
                  <li>6.4. USE OF FOSS</li>
                  <p>
                    Company agrees that as part of a Deliverable, Samsung may make use of FOSS. If
                    so, Samsung will include in the applicable Order a list of such FOSS, including
                    notice of the associated FOSS license(s) and terms as of its delivery to Company
                    as part of a Deliverable. Company acknowledges and agrees that its use and
                    distribution of any such FOSS is subject to the terms of the applicable FOSS
                    license(s), and that it is responsible for its compliance with the terms of such
                    FOSS license(s). Company expressly acknowledges and agrees that, prior to
                    copying, modifying, or distributing any FOSS, it will confirm that it has all
                    necessary rights and permissions to do so from the applicable third party
                    licensor (the “licensor”), which confirmation may include obtaining a separate
                    license from the licensor expressly authorizing it to do so.
                  </p>
                </ul>
                <li>FEEDBACK</li>
                <p>
                  Company may from time to time, provide suggestions, enhancement or other feedback
                  to Samsung with respect to the Services or Deliverables or related documentation
                  (collectively, “Feedback”). Company agrees that all Feedback is and shall be given
                  by Company entirely voluntarily. Samsung shall be free to use disclose, reproduce,
                  license or otherwise distribute and exploit the Feedback in its discretion,
                  without restriction, accounting, or other obligation of any kind or nature. The
                  use of the Feedback will not impose any confidentiality or other obligations on
                  Samsung relating to the Feedback. However, Samsung agrees not to disclose the
                  source of such Feedback to third parties.
                </p>
                <li>INDEMNIFICATION</li>
                <ul>
                  <li>8.1. INDEMNIFICATION BY COMPANY</li>
                  <p>
                    Company shall be solely responsible for its use of the Services and Deliverables
                    in connection with its business operations, including, but not limited to,
                    protecting against loss or error resulting from use of any or all of the
                    Services or Deliverables. Company will indemnify, defend and hold harmless
                    Samsung, its Affiliates, and each of their respective officers, directors,
                    employees and agents from and against any and all losses, costs, liabilities or
                    expenses (including but not limited to reasonable attorney’s fees) arising,
                    directly or indirectly, out of or in connection with (i) the willful or
                    negligent acts or omissions of Company; (ii) Company’s breach of Section 1.5,
                    3.2, 3.3, 6.4, or 12.5 of these TOS; (iii) the failure of Company to hold all
                    necessary rights to, and interest in, any properties, materials (including
                    Company Materials) that Company makes available to Samsung to perform Samsung’s
                    obligations under these TOS or any Order; or (iv) a third party claim that
                    Company’s use of the Services or Deliverables for a purpose or in a manner for
                    which they were not intended or designed; or (v) any claim, action or other
                    proceeding related to any of the situations or events described in subparts (A)
                    through (E) of Section 8.2.
                  </p>
                  <li>8.2. INDEMNIFICATION BY SAMSUNG</li>
                  <p>
                    Samsung shall defend or settle any third party claim that the Services infringes
                    third party intellectual property, provided that Company (i) promptly notifies
                    Samsung in writing of such claim; (ii) grants Samsung sole control over the
                    defense and settlement thereof pursuant to Section 8.3 and (iii) cooperates with
                    any request by Samsung for assistance in defending such claim; provided,
                    however, that Samsung will have no obligation or liability with respect to any
                    such claim if the claim is based, in whole or in part, on (A) the specifications
                    set forth in the applicable Orders, or any modifications made by Samsung thereto
                    pursuant to Company’s instructions or request; (B) any combination of the
                    Services with Company or third party services or products or Company Materials;
                    (C) the use of the Services for a purpose or in a manner for which they were not
                    intended or designed; (D) any modification made to the Services by Company or
                    any third party; (E) any intellectual property right owned or licensed by
                    Company, including any Company Materials; or (F) any FOSS. The foregoing
                    constitutes Samsung’s entire liability and Company’s sole and exclusive remedy
                    for any infringement claim arising hereunder.
                  </p>
                  <li>8.3. INDEMNIFICATION PROCEDURES</li>
                  <p>
                    Promptly after receipt by either party (in each case, an “Indemnitee”) of notice
                    of the commencement or threatened commencement of any action or proceeding
                    involving a claim in respect of which Indemnitee is entitled to indemnification
                    under this Section 8, Indemnitee shall notify the other party (in such instance,
                    the “Indemnitor”) of such claim. No delay or failure to so notify Indemnitor
                    shall relieve Indemnitor of its obligations under these TOS except to the extent
                    that Indemnitor has suffered actual prejudice by such delay or failure. Within
                    thirty (30) days following receipt of notice from Indemnitee relating to any
                    claim, but no later than fifteen (15) days before the date on which any response
                    to a complaint or summons is due, if applicable, Indemnitor shall notify
                    Indemnitee that Indemnitor shall assume control of the defense and settlement of
                    such claim (a “Notice of Assumption”).
                  </p>
                  <p>
                    If Indemnitor delivers a Notice of Assumption within the required notice period,
                    Indemnitor shall assume control (subject to Indemnitee’s right to participate at
                    Indemnitee’s cost and expense) over the defense and settlement of the claim and
                    diligently defend the claim; provided, however, that (i) Indemnitor shall keep
                    Indemnitee fully apprised as to the status of the defense; and (ii) Indemnitor
                    shall obtain the prior written approval of Indemnitee before entering into any
                    settlement of such claim that does not include a full and final release of
                    Indemnitee, or any settlement asserting any liability against Indemnitee,
                    imposing any obligations or restrictions on Indemnitee, ceasing to defend
                    against such claim or otherwise adversely impacting Indemnitee.
                  </p>
                  <p>
                    If Indemnitor does not deliver a Notice of Assumption relating to any claim
                    within the required notice period, or if, after the assumption of the defense by
                    Indemnitor, Indemnitor has failed to defend the claim diligently, Indemnitee
                    shall have the right to defend the claim in such manner as it may deem
                    appropriate. Indemnitor shall promptly reimburse Indemnitee for all reasonable
                    costs and expenses incurred by Indemnitee, including attorneys’ fees, in
                    connection therewith to the full extent of Indemnitor’s indemnification
                    obligation under this Section 8.
                  </p>
                </ul>
                <li>TERM AND TERMINATION</li>
                <ul>
                  <li>9.1. TERM</li>
                  <p>
                    These TOS shall be effective as of the Service Start Date and shall remain in
                    effect during the Service Term.
                  </p>
                  <li>9.2. TERMINATION FOR INSOLVENCY</li>
                  <p>
                    Samsung may immediately terminate an Order by written notice to Company if (i)
                    Company shall become insolvent or make a general assignment for the benefit of
                    creditors; (ii) Company files a petition for bankruptcy or has filed against it
                    a petition for bankruptcy which is not dismissed within thirty (30) days; or
                    (iii) Company proposes any dissolution or becomes involved in legal, financial
                    or reorganization proceedings that, in the opinion of Samsung, interfere with
                    the diligent performance and satisfactory completion of Company’s obligations
                    hereunder.
                  </p>
                  <li>9.3. TERMINATION FOR BREACH</li>
                  <p>
                    Either party may terminate an Order immediately upon written notice to the other
                    party in the event that the other is in material breach or default under these
                    TOS or the terms of an Order and fails to remedy such breach within thirty (30)
                    days of notice thereof from the non-breaching party.
                  </p>
                  <li>9.4. SURVIVAL</li>
                  <p>
                    With respect to an Order, any provision of these TOS that contemplates
                    performance or observance subsequent to any termination or expiration of an
                    Order shall survive any termination or expiration and continue in full force and
                    effect.
                  </p>
                </ul>
                <li>LIMITATION OF LIABILITY</li>
                <p>
                  The failure or delay of Samsung in its performance of its obligations under these
                  TOS or any Order is excused to the extent such failure is a result of: (i) any act
                  or omission of Company or any entity or individual acting on Company’s behalf
                  including Company’s failure to perform (or cause to be performed) its obligations
                  hereunder, (ii) unavailability of Company’s materials or systems, including those
                  provided by third parties, (iii) the reliance of Samsung on instructions,
                  authorizations, approvals or other information from Company’s representative(s);
                  or (iv) any act or omission of a third party not under the control of Samsung.
                  Samsung will use commercially reasonable efforts to perform the Services and
                  provide the Deliverables notwithstanding such circumstances, and Company agrees to
                  reimburse Samsung for any additional charges and expenses incurred as a result of
                  such efforts.
                </p>
                <p>
                  IN NO EVENT SHALL SAMSUNG (OR ITS SUPPLIERS OR AFFILIATES) BE LIABLE TO COMPANY OR
                  ANY THIRD PARTY FOR ANY PUNITIVE, SPECIAL, INDIRECT, CONSEQUENTIAL, INCIDENTAL,
                  EXEMPLARY, LOST PROFIT OR OTHER SIMILAR DAMAGES ARISING OUT OF, OR IN CONNECTION
                  WITH, THESE TOS OR ANY ORDER, EVEN IF IT HAS BEEN ADVISED OF THE POSSIBILITY OF
                  SUCH DAMAGES. IN NO EVENT SHALL SAMSUNG’S TOTAL AGGREGATE LIABILITY FOR DAMAGES OF
                  ANY NATURE UNDER OR IN CONNECTION WITH AN ORDER, REGARDLESS OF THE FORM OF THE
                  ACTION OR THE THEORY OF RECOVERY, EXCEED THE AMOUNT PAID BY COMPANY TO SAMSUNG
                  UNDER THE APPLICABLE ORDER GIVING RISE TO THE ACTION OR CLAIM. IN NO EVENT SHALL
                  SAMSUNG HAVE ANY LIABILITY ARISING OUT ANY OF COMPANY’S MATERIALS PROVIDED TO
                  SAMSUNG IN CONNECTION WITH THE SERVICES HEREUNDER.
                </p>
                <li>FORCE MAJEURE</li>
                <p>
                  Samsung shall not be held responsible for any delay or failure in performance of
                  any part of these TOS or an Order to the extent such delay or failure is
                  attributable to a force majeure event, including without limitation: power or
                  telecommunications failures or outages, hardware failures, software defects,
                  fires, explosions, epidemics, riots, civil disturbances, malicious damage,
                  industry-wide shortages of labor or materials, work stoppages, strikes and other
                  similar events, labor disputes, accidents, weather, floods, storms, earthquakes
                  and other natural disasters, acts of God, war, terrorism, blockades, embargoes,
                  prohibitions or restrictions or changes in applicable law or delays arising from
                  compliance with any law or government regulation or other similar causes beyond
                  its control and without the fault or negligence of Samsung or its subcontractors.
                </p>
                <li>GENERAL</li>
                <ul>
                  <li>12.1. NOTICES</li>
                  <p>
                    All notices, demands and other communications shall be in writing and shall be
                    deemed to have been given if delivered personally, or three days after mailing
                    by certified mail (return receipt requested) or national overnight carrier (with
                    proof of delivery) to the respective addresses listed in the Order or to such
                    other address as either party may designate by providing notice in accordance
                    with this Section 12.1.
                  </p>
                  <li>12.2. ASSIGNMENT</li>
                  <p>
                    Samsung may assign an Order without the prior consent of Company. Company may
                    not assign an Order without the prior consent of Samsung. Any permitted assignee
                    or successor of a party’s rights and obligations under an Order shall be bound
                    by the TOS. Any attempted assignment in violation of the foregoing shall be void
                    and of no effect.
                  </p>
                  <li>12.3. INDEPENDENT CONTRACTOR</li>
                  <p>
                    The relationship between the parties under these TOS is that of independent
                    contractors, and nothing contained herein shall be construed to create a
                    relationship of employer and employee or principal and agent between Company and
                    Samsung nor shall it be deemed a partnership, joint venture or fiduciary
                    relationship for any purpose. Neither party shall act or have authority to act
                    for or on behalf of the other party, and all representations made and agreements
                    executed by each party shall be such party’s sole responsibility.
                  </p>
                  <li>12.4. GOVERNING LAW; JURISDICTION</li>
                  <p>
                    These TOS will be governed by, and construed and enforced in accordance with,
                    the laws of Republic of Korea, excluding the principles of conflict of laws
                    thereof that would cause the laws of another jurisdiction to apply. The parties
                    hereby irrevocably submit to the jurisdiction of the Courts in Republic of
                    Korea.
                  </p>
                  <li>12.5. COMPLIANCE WITH LAWS</li>
                  <p>
                    Each party shall comply, at its own expense, with the provisions of all
                    applicable foreign, federal, state, county and local laws, ordinances,
                    regulations and codes, including procurement of any required permits or
                    certificates, applicable to such party’s performance hereunder.
                  </p>
                  <li>12.6. EXPORT CONTROL</li>
                  <p>
                    Company shall not transfer, directly or indirectly, any product, technical data,
                    software or Confidential Information furnished hereunder to any country without
                    first obtaining all required licenses or other governmental approvals and
                    otherwise complying with all applicable export control laws.
                  </p>
                  <li>12.7. INTERPRETATION; PRECEDENCE</li>
                  <p>
                    These TOS shall be interpreted in accordance with its terms and without any
                    strict construction in favor of or against either party. The section headings
                    included herein are for convenience only and shall not limit or otherwise affect
                    the interpretation of any of the terms or provisions herein. Each Order entered
                    into by the parties during the Service Term shall be governed by these TOS.
                  </p>
                  <p>
                    In the event of a conflict between the terms in these TOS and the terms in an
                    Order, the terms in these TOS will take precedence unless the Order expressly
                    indicates otherwise.
                  </p>
                  <li>12.8. ENTIRE AGREEMENT; SEVERABILITY; COUNTERPARTS</li>
                  <p>
                    These TOS, including all Orders referenced herein, constitute the entire
                    agreement of the parties with respect to the subject matter hereof and supersede
                    all prior verbal or written agreements with respect to such subject matter,
                    including any previous Nondisclosure Agreements or similar agreements between
                    the parties.
                  </p>
                  <p>
                    No Waiver. The failure of Samsung to enforce at any time any of the provisions
                    of these TOS, or the failure by Samsung to require at any time performance by
                    You of any of the provisions of these TOS, shall in no way be construed to be a
                    present or future waiver of such provisions, nor in any way affect the right of
                    Samsung to enforce such provision thereafter. The express waiver by Samsung of
                    any provision, condition or requirement of these TOS shall not constitute a
                    waiver of any future obligation to comply with such provision, condition or
                    requirement.
                  </p>
                  <p>
                    If Samsung makes changes to these TOS, Samsung will update such revised TOS on
                    this website. Samsung will notify you before making any material changes to
                    these TOS. You may stop using the Service at any time if you do not agree to
                    such changes, but you will be deemed to have understood and accepted them by
                    continuing to use the service.
                  </p>
                  <p>
                    If any term or provision of these TOS shall be found to be illegal or
                    unenforceable, such illegal or unenforceable provision will be deemed modified
                    to the limited extent required to permit its enforcement in a manner most
                    closely approximating the intention of the parties expressed herein.
                  </p>
                  <p>
                    These TOS may be entered into in any number of counterparts and by the parties
                    to it on separate counterparts each of which when executed and delivered shall
                    be an original but all these counterparts shall together constitute one and the
                    same instrument.
                  </p>
                  <li>12.9. HAZARDOUS ACTIVITY</li>
                  <p>
                    The Services and Deliverables are not intended for use, and shall not be used,
                    in the operation of nuclear facilities, aircraft navigation, communication
                    systems, air traffic control machines, medical devices, medical equipment or
                    other activities in which the failure of the Services to attain a desired result
                    could lead to death, personal injury, or physical or environmental damage.
                  </p>
                  <li>12.10. PUBLICITY; ADVERTISING</li>
                  <p>
                    Company shall not advertise, promote or otherwise publicize matters relating to
                    these TOS, including the existence of any relationship between the parties,
                    without the prior written consent of Samsung. Except as otherwise expressly
                    provided in these TOS, Company shall not use any trade name, trademark, service
                    mark, insignia, symbol or other identification of Samsung without Samsung’s
                    prior written permission.
                  </p>
                  <li>12.11. AUDIT</li>
                  <p>
                    Within [60 days] upon written request and [monthly] during the Term, Company
                    will make available to Samsung reports to meet the obligations under this TOS.
                    In the event that Samsung on reasonable grounds and in good faith disputes the
                    report submitted by Company, Company shall provide Samsung with reasonable
                    information and materials evidencing the report.
                  </p>
                  <p>
                    During the Term and for at least 2 years thereafter, Company will keep accurate
                    and complete accounts and Service records and, if applicable, expense reports
                    showing all costs or expenses incurred, and subject to audit by Samsung.
                  </p>
                </ul>
              </ol>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const getServerSideProps = withOpenAccessPage(async ({ loggedInUser }) => {
  const props = {}
  if (loggedInUser) {
    props.loggedInUser = loggedInUser
  }
  return {
    props
  }
})

export default EulaEts
